import React from 'react';
import PageTitle from '../PageTitle';
import HuckleberryQuote from '../Quote';
import { FaQuoteLeft } from 'react-icons/fa'; // Import the quote icon
import IconComponent from '../IconComponent';
import SectionTestimonials from '../Section.Testimonials';
import { Helmet } from 'react-helmet';

const About = () => {
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | About</title>
        <meta property="og:title" content="I'm Your Huckleberry | About" />
        <meta property="og:description" content="We are experienced, friendly, and trustworthy professionals who take pride in
                    our work. Whether you need regular maintenance, or specialized services like
                    move-in/move-out cleaning, we’re here to help. We use eco-friendly products
                    whenever possible and always follow best practices to ensure your home or office
                    is cleaned to perfection." />
        <meta property="og:image" content='https://huckleberrycleaning.netlify.app/images/social.png'/>
        <meta property="og:url" content="https://www.huckleberrycleaning.com/" />
        <meta property="og:type" content="website" />
      </Helmet>

      <PageTitle title="About Us" className="bg-light-blue" textColor="black">
        <p className="text-center mx-auto">
          Our story is a passion for clean spaces and happy clients
        </p>
      </PageTitle>
      <section className="w-100 py-5">
        <div className="container">
          <div className="row align-items-start">
            <div className="row">
              <div className="col-12">
                {/* Who We Are Section */}
                <h3 className="mb-4">Who We Are</h3>
                <div className="bg-light p-4 rounded-lg shadow-sm mb-4">
                  <p>
                    We are experienced, friendly, and trustworthy professionals who take pride in
                    our work. Whether you need regular maintenance, or specialized services like
                    move-in/move-out cleaning, we’re here to help. We use eco-friendly products
                    whenever possible and always follow best practices to ensure your home or office
                    is cleaned to perfection.
                  </p>
                  <p>
                    We’ve been proudly serving our community with top-notch residential and
                    commercial cleaning services, maid services, and housekeeping services for over
                    a decade. The journey began 10 years ago, and for the past 8 years, we’ve been
                    offering professional, high-quality cleaning to homeowners and businesses alike.
                    Fully licensed and insured for 5 years, we are committed to maintaining the
                    highest standards of professional cleaning services.
                  </p>
                  <p>
                    At I'm Your Huckleberry LLC, our mission is simple: to provide tailored,
                    thorough and affordable cleaning services that leave our clients happy and their
                    spaces not only clean, but just the way they like them!
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              {/* Left 1/3 Column with stylized quote box */}
              <div className="col-8 mx-auto col-md-4  position-relative d-flex align-items-center justify-content-center order-1 ">
                <div
                  className="w-100"
                  style={{
                    backgroundImage: `url('./images/pillow.webp')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    height: '300px', // Default height for larger screens
                    zIndex: 1,
                  }}
                >
                  <div className="overlay"></div>
                  <div
                    style={{ zIndex: 2, padding: '20px', color: 'white' }}
                    className="d-flex flex-column justify-content-center align-items-center"
                  >
                    <IconComponent
                      icon={FaQuoteLeft}
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        fontSize: '6rem',
                        color: `var(--green')`,
                        zIndex: 10,
                        transform: 'translate(-50%, -50%)',
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Right 2/3 Column with Dictionary-Style Quote */}
              <div className="col-md-8 order-2 ">
                <div className="p-md-4">
                  <p className="h5 font-italic">"I’m your huckleberry"</p>
                  <p className="mt-2">
                    <strong>Definition:</strong> A phrase used to express a willingness to
                    confidently take on a challenge or task. It suggests that someone is the right
                    person for a particular job or situation.
                  </p>
                  <p className="mt-2 font-italic">
                    <strong>Example:</strong> “If you're looking for someone to get the job done
                    right, I’m your huckleberry.”
                  </p>
                  <p className="mt-2">
                    <strong>Origin:</strong> (Historical/Colloquial) Popularized by the 1993 film{' '}
                    <em>Tombstone</em>, where Doc Holliday used it to mean he was the one for the
                    job — often a duel. <strong>RIP Val Kilmer.</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SectionTestimonials />

      {/* Custom Media Query for Mobile */}
      <style>{`
        @media (max-width: 767px) {
          .col-md-4 {
            height: 400px; /* Increase height for the image on mobile */
          }
          .col-md-4 .overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4); /* Ensure overlay covers the whole image */
          }
        }
      `}</style>
    </>
  );
};

export default About;
